var kindOf = require('./kindOf');
/**
 * Check if value is from a specific "kind".
 */
function isKind(val, kind) {
  return kindOf(val) === kind;
}
module.exports = isKind;